/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareDocumentTypeItem
 */
export interface MatrixCareDocumentTypeItem {
    /**
     * MatrixCare DocumentTypeID GUID — passed through to uploadDocument.
     */
    id: string;
    /**
     * 
     */
    label: string;
    /**
     * Whether this document type binds to a specific patient (as opposed to a facility-wide document).
     */
    is_patient_specific: boolean;
}

/**
 * Check if a given object implements the MatrixCareDocumentTypeItem interface.
 */
export function instanceOfMatrixCareDocumentTypeItem(value: object): value is MatrixCareDocumentTypeItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('is_patient_specific' in value) || value['is_patient_specific'] === undefined) return false;
    return true;
}

export function MatrixCareDocumentTypeItemFromJSON(json: any): MatrixCareDocumentTypeItem {
    return MatrixCareDocumentTypeItemFromJSONTyped(json, false);
}

export function MatrixCareDocumentTypeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareDocumentTypeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'is_patient_specific': json['is_patient_specific'],
    };
}

export function MatrixCareDocumentTypeItemToJSON(json: any): MatrixCareDocumentTypeItem {
    return MatrixCareDocumentTypeItemToJSONTyped(json, false);
}

export function MatrixCareDocumentTypeItemToJSONTyped(value?: MatrixCareDocumentTypeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'is_patient_specific': value['is_patient_specific'],
    };
}

